import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import FAQSubheading from '../FAQSubheading';

const FAQPage = props => {
  const { content, classes } = props;

  return (
    <div className={classes.root}>
      <div className={classes.innerWrapper}>
        <div className={classes.headingContainer}>
          <h1 className={classes.heading}>{content.title}</h1>
        </div>
        {content.subheadingCollection &&
          content.subheadingCollection.map(subheading => (
            <FAQSubheading subheading={subheading} classes={classes} />
          ))}
      </div>
    </div>
  );
};

FAQPage.propTypes = {
  content: PropTypes.object,
  classes: PropTypes.object,
};

export default withStyles(styles)(FAQPage);
